"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.updateInputStateValueIfChanged = updateInputStateValueIfChanged;
var _updateInputStateValue = require("../update-input-state-value");
var _utils = require("../../utils");
function updateInputStateValueIfChanged(inputElement, stateKey, newValue) {
  return function (getState, dispatch) {
    const {
      inputStates
    } = getState();
    const shouldUpdate = (0, _utils.shouldUpdateInputState)(inputStates.get(inputElement)[stateKey], newValue);
    if (shouldUpdate) {
      dispatch((0, _updateInputStateValue.updateInputStateValue)(inputElement, stateKey, newValue), true);
    }
  };
}